module.exports = __webpack_public_path__ + "assets/d083dc138a7fd40c5f17ca00cd0b5f48.mp3";